module.exports = __webpack_public_path__ + "static/media/equivalence-energy.7cd489a3.svg";